( function() {

    /**
     * Used for small init functions.
     */

    /**
     * Example plain js foreach function
     */
    const initSandwiches = () => {

        var sandwiches = document.querySelectorAll('h1');

        if ( sandwiches.length ) {
            sandwiches.forEach(function (sandwich, index) {
                console.log(sandwich.textContent + " " + index); // The element
            });
        } else {
            alert('Where is your H1?');
        }
    }

        /**
     * Toggle Search
     */
    const toggleSearch = () => {
        //document.querySelector('.search-form .search-submit').setAttribute('id', 'search-submit');
        const searchToggleLink = document.getElementById('search-toggle'),
              searchInput = document.querySelector('.search-form .search-field'),
              searchFormEl = document.querySelector('.search-form'),
              searchSubmit = document.querySelector('.search-submit');

        searchSubmit.setAttribute('tabindex', '-1');
        searchInput.setAttribute('tabindex', '-1');

        searchToggleLink.addEventListener( 'click', function( event ) {
            searchFormEl.classList.toggle('toggled');

            // if has class toggled set focus to searchInput
            if ( searchFormEl.classList.contains('toggled') ) {
                searchInput.focus();
                searchInput.value = '';
            }
        } );

        //setInterval(function() { console.log(document.querySelector(":focus")); }, 1000);
    }

    document.addEventListener("DOMContentLoaded", () => {
        //initSandwiches();
        /**
         * Init lazyload - used for lazyloading images and iframes that have class "lazy".
         * Plugin is enqueued in functions.php
         * more examples: https://github.com/verlok/vanilla-lazyload#-getting-started---html
         */
        var lazyLoadInstance = new LazyLoad();

        //toggleSearch();

    });

}() );
